import React, { useRef } from 'react'
import CTA from './CTA'
import ME from '../../assets/me.png'
import HeaderSocials from './HeaderSocials'
import './header.css'
import { useTypewriter, Cursor, Typewriter } from 'react-simple-typewriter'
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import AlphabetSoup from 'react-alphabet-soup'

const Header = () => {
  const { text } = useTypewriter({
    words: ['"What if changing the world was just about being here, by showing up no matter how many times we get told we don’t belong?    by staying true even when we’re shamed into being false?    by believing in ourselves even when we’re told we’re too different? And if we all held on to that, if we refuse to budge and fall in line, if we stood our ground for long enough, just maybe, The world can’t help but change around us.” ~ Mr.Robot'],
    loop: 2,
    cursorStyle: '_',
    typeSpeed: 40,
    deleteSpeed: 0,
    fontWeight: "bold",
  })

  // const particlesInit = async (main) => {
  //   console.log(main);

  //   // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
  //   // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
  //   // starting from v2 you can add only the features you need reducing the bundle size
  //   await loadFull(main);
  // };

  // const particlesLoaded = (container) => {
  //   console.log(container);
  // };

  return (
    <section id="header">
      
{/*       
      <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        fullScreen: {
          enable: false,
          zIndex: 0
        },
        background: {
          color: {
            value: "#80461B",
          },
        },
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            push: {
              quantity: 2,
            },
            repulse: {
              distance: 50,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#ffffff",
          },
          links: {
            color: "#ffffff",
            distance: 100,
            enable: true,
            opacity: 0.2,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outModes: {
              default: "bounce",
            },
            random: false,
            speed: 6,
            straight: false,
          },
          number: {
            value: 100,
            limit: 200,
            density: {
              enable: true,
              value_area: 700
            }
          },
          opacity: {
            value: 0.2,
          },
          shape: {
            type: "circle",
          },
          size: {
            value: { min: 1, max: 5 },
          },
        },
        detectRetina: true,
      }}
    /> */}
    <hr />
    <p className='p__tag'>&nbsp;</p>
    <div className="container header__container">
          <h5>Hello I"m</h5>
          <h1>Lyons Masawa</h1>
          <h5 className="text-light">
            Fullstack Developer || Graphic Designer
          </h5>
          <p>&nbsp;</p>
          <span style={{ color: 'white', fontWeight: '600', fontSize: '1.3rem', padding: "5px 1rem" }} className="b__link">
            {/* Style will be inherited from the parent element */}
            <Typewriter
              words={['', '','', '..', '.', '...', 'L', '..', '..', 'Y', '.', '..', 'O', '...', '.', 'N', '.', '...', 'S', '..', 'LYONS', '.', '...', '.', '..', '.', '...', 'W', '..', '..', 'E', '.', '..', 'L', '...', '.', 'C', '.', '...', 'O', '.', '...', 'M', '.', '...', 'E', '..', 'WELCOME', '.', '', '', '', '', '', '',]}
              loop={0}
              cursor
              cursorStyle='_'
              typeSpeed={50}
              deleteSpeed={10}
              delaySpeed={100}
            />
          </span>
          <CTA />
          <HeaderSocials />

        <div className="me__full">
          <div className="text__soup">
            <AlphabetSoup text=">>> DARE TO DREAM! <<<" Sorting='costFunction' TransitionStyle='progressive' TransitionTiingFunction='cubic-bezier(1, 0.24, 0.25, 1)' TransitionSpeedMultiplier="0.5" />
          </div>
          <div className="me">
            <img src={ME} alt="me" />
          </div>
          <div className="text__soup">
            <AlphabetSoup text=">>> DARE TO DO! <<<" Sorting='costFunction' TransitionStyle='progressive' TransitionTiingFunction='cubic-bezier(1, 0.24, 0.25, 1)' TransitionSpeedMultiplier="0.5" />
          </div>
        </div>
        <p>&nbsp;</p>
        <h4 style={{ color: 'white', padding: '2rem 4rem', fontWeight: '200', }}>{text}</h4>
        <a href="#contact" className='scroll__down'>Scroll Down</a>
    </div>

    </section>
  )
} 

export default Header